import { render, staticRenderFns } from "./TotalRevenueGraph.vue?vue&type=template&id=4a2c8790&scoped=true"
import script from "./TotalRevenueGraph.vue?vue&type=script&lang=js"
export * from "./TotalRevenueGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2c8790",
  null
  
)

export default component.exports